"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobile = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _GtmContext = require("@airasia/phoenix-common/common/GtmContext");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Button = _interopRequireDefault(require("../Button"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _Image = _interopRequireDefault(require("../Image"));
var _Paragraph = _interopRequireDefault(require("../Paragraph"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant = require("../constant");
var _GenericPopUp = _interopRequireDefault(require("./GenericPopUp.proptypes"));
var _constant2 = require("./constant");
var _constant3 = require("../JourneyPriceCTA/constant");
var _constants = require("../Paragraph/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Container = _styledComponents.default.div.withConfig({
  displayName: "GenericPopUp__Container",
  componentId: "sc-1q4u96p-0"
})(["display:flex;flex-direction:column;padding:", ";"], function (_ref) {
  var theme = _ref.theme,
    isMobile = _ref.isMobile;
  return isMobile ? "".concat(theme.space.small, " ").concat(theme.space.standard, " ").concat(theme.space.semi) : 'none';
});
var ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "GenericPopUp__ButtonWrapper",
  componentId: "sc-1q4u96p-1"
})(["display:flex;flex-wrap:", ";margin-top:", ";justify-content:", ";position:", ";background-color:", ";padding-top:", ";padding-bottom:", ";margin-bottom:", ";bottom:", ";a{align-items:center;display:flex;justify-content:center;}"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 'wrap-reverse' : 'none';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? _constant2.SPACES.MOBILE : _constant2.SPACES.DESKTOP;
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? 'center' : 'flex-end';
}, function (_ref5) {
  var isStickyBtn = _ref5.isStickyBtn;
  return isStickyBtn ? 'sticky' : 'none';
}, function (_ref6) {
  var isStickyBtn = _ref6.isStickyBtn;
  return isStickyBtn ? 'white' : 'transparent';
}, function (_ref7) {
  var isStickyBtn = _ref7.isStickyBtn,
    theme = _ref7.theme;
  return isStickyBtn ? theme.space.normal : 'none';
}, function (_ref8) {
  var isStickyBtn = _ref8.isStickyBtn,
    theme = _ref8.theme;
  return isStickyBtn ? theme.space.normal : 'none';
}, function (_ref9) {
  var isStickyBtn = _ref9.isStickyBtn,
    theme = _ref9.theme;
  return isStickyBtn ? theme.space.XXXSmall : 'none';
}, function (_ref10) {
  var isStickyBtn = _ref10.isStickyBtn;
  return isStickyBtn ? '0' : 'none';
});
var ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "GenericPopUp__ImageWrapper",
  componentId: "sc-1q4u96p-2"
})(["margin:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return "".concat(theme.space.standard, " auto");
});
var UlContainer = _styledComponents.default.ul.withConfig({
  displayName: "GenericPopUp__UlContainer",
  componentId: "sc-1q4u96p-3"
})(["margin-block-start:0px;margin-block-end:0px;padding-left:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.normal;
});
var BulletItem = _styledComponents.default.li.withConfig({
  displayName: "GenericPopUp__BulletItem",
  componentId: "sc-1q4u96p-4"
})(["color:", ";"], function (_ref13) {
  var theme = _ref13.theme,
    color = _ref13.color;
  return theme.colors[color];
});
var TextAfterBulletWrapper = _styledComponents.default.div.withConfig({
  displayName: "GenericPopUp__TextAfterBulletWrapper",
  componentId: "sc-1q4u96p-5"
})(["*:not(:last-child){margin-bottom:", ";}"], function (_ref14) {
  var theme = _ref14.theme;
  return "".concat(theme.space.micro);
});
var ParaContainer = _styledComponents.default.div.withConfig({
  displayName: "GenericPopUp__ParaContainer",
  componentId: "sc-1q4u96p-6"
})(["#generic-popup-para{p{margin-bottom:unset;}}"]);
var BulletParaContainer = _styledComponents.default.div.withConfig({
  displayName: "GenericPopUp__BulletParaContainer",
  componentId: "sc-1q4u96p-7"
})(["#generic-popup-para{ul{padding-left:", ";}}"], function (_ref15) {
  var theme = _ref15.theme;
  return "".concat(theme.space.normal);
});
var isMobile = function isMobile(bp) {
  if (bp === _constant.DEVICE_TYPE.MOBILE) {
    return true;
  }
  return false;
};
exports.isMobile = isMobile;
var GenericPopUp = function GenericPopUp(props) {
  var headingText = props.headingText,
    mainText = props.mainText,
    bulletText = props.bulletText,
    textAfterBulletPoints = props.textAfterBulletPoints,
    buttonTextLearnMore = props.buttonTextLearnMore,
    buttonTextOk = props.buttonTextOk,
    handleClick = props.handleClick,
    handleCloseClick = props.handleCloseClick,
    redirectionURL = props.redirectionURL,
    target = props.target,
    theme = props.theme,
    openModal = props.openModal,
    viewPort = props.viewPort,
    accessible = props.accessible,
    showCloseIcon = props.showCloseIcon,
    customProperties = props.customProperties,
    hasImage = props.hasImage,
    imageConfig = props.imageConfig,
    _props$primaryButtonP = props.primaryButtonProps,
    primaryButtonProps = _props$primaryButtonP === void 0 ? {} : _props$primaryButtonP,
    _props$secondaryButto = props.secondaryButtonProps,
    secondaryButtonProps = _props$secondaryButto === void 0 ? {} : _props$secondaryButto,
    mainParaText = props.mainParaText,
    bulletParaText = props.bulletParaText,
    paraAfterBulletPoints = props.paraAfterBulletPoints,
    isStickyBtn = props.isStickyBtn,
    airAsiaPlusProps = props.airAsiaPlusProps,
    fireClientGtm = props.fireClientGtm,
    gtmErrorObj = props.gtmErrorObj,
    handleLearnMore = props.handleLearnMore;
  var gtmContext = (0, _GtmContext.useGtmContext)();
  (0, _react.useEffect)(function () {
    if (fireClientGtm) {
      var gtmObj = _utilities.default.createGTMObject(gtmErrorObj, gtmContext);
      fireClientGtm(gtmObj);
    }
  }, [openModal, fireClientGtm]);
  var buttonWidth = isMobile(viewPort) ? _constant2.BUTTON_TYPE.BUTTON_FULL_WIDTH : _constant2.BUTTON_TYPE.BUTTON_WIDTH_DESKTOP;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getBulletList = function getBulletList() {
    if (bulletText === undefined) return;
    // eslint-disable-next-line consistent-return
    return bulletText && bulletText.map(function (entry, id) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement(BulletItem, {
          key: id,
          color: _constant2.COLORS.GREY_DARK
        }, /*#__PURE__*/_react.default.createElement(_Text.default, {
          accessible: true,
          color: _constant2.COLORS.GREY_DARK,
          theme: theme,
          type: _constant2.SIZES.SMALL
        }, entry))
      );
    });
  };
  var getTextAfterBulletPoints = function getTextAfterBulletPoints() {
    if (!textAfterBulletPoints || !textAfterBulletPoints.length) {
      return null;
    }
    if (typeof textAfterBulletPoints === 'string') {
      return /*#__PURE__*/_react.default.createElement(_Text.default, {
        accessible: true,
        color: _constant2.COLORS.GREY_DARK,
        theme: theme,
        type: _constant2.SIZES.SMALL
      }, textAfterBulletPoints);
    }
    return textAfterBulletPoints.map(function (paragraph) {
      return /*#__PURE__*/_react.default.createElement(_Text.default, {
        accessible: true,
        color: _constant2.COLORS.GREY_DARK,
        theme: theme,
        type: _constant2.SIZES.SMALL
      }, paragraph);
    });
  };
  var getMarginForButton = function getMarginForButton(isMobileDevice) {
    var marginArray = [];
    if (isMobileDevice) {
      marginArray = [_constant2.SIZES.TINY, _constant2.SIZES.NONE, _constant2.SIZES.NONE, _constant2.SIZES.NONE];
    } else {
      marginArray = [_constant2.SIZES.NONE, _constant2.SIZES.SMALL, _constant2.SIZES.NONE, _constant2.SIZES.NONE];
    }
    return marginArray;
  };
  var generateContent = function generateContent() {
    var _airAsiaPlusProps$con;
    var includeIcons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return (airAsiaPlusProps === null || airAsiaPlusProps === void 0 || (_airAsiaPlusProps$con = airAsiaPlusProps.content) === null || _airAsiaPlusProps$con === void 0 ? void 0 : _airAsiaPlusProps$con.map(function (item, index) {
      return _objectSpread({
        id: index,
        text: (item === null || item === void 0 ? void 0 : item.text) || item
      }, includeIcons && {
        icon: item === null || item === void 0 ? void 0 : item.icon,
        iconColor: item === null || item === void 0 ? void 0 : item.iconColor
      });
    })) || [];
  };
  var renderContent = function renderContent() {
    if (!(airAsiaPlusProps !== null && airAsiaPlusProps !== void 0 && airAsiaPlusProps.content) || airAsiaPlusProps.content.length === 0) {
      return [];
    }
    return [{
      paragraph: generateContent(true)
    }];
  };
  var getMain = function getMain() {
    var isMoveTheme = theme === _constant3.THEMES.MOVE;
    return /*#__PURE__*/_react.default.createElement(_Modal.default, {
      accessible: accessible,
      backgroundColor: "default",
      openModal: openModal,
      width: isMobile(viewPort) ? _constant2.CONTAINER_WIDTH.MOBILE : _constant2.CONTAINER_WIDTH.DESKTOP,
      overlayBackgroundColor: "black",
      overlayOpacity: "0.8",
      theme: theme,
      viewPort: viewPort,
      zIndex: 9999,
      showCloseIcon: showCloseIcon,
      onClose: handleCloseClick,
      modalCenter: true,
      isStickyBtn: isStickyBtn,
      customProperties: customProperties
    }, /*#__PURE__*/_react.default.createElement(Container, {
      isMobile: isMobile(viewPort)
    }, hasImage && imageConfig.imageURL && /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: imageConfig.imageURL,
      height: imageConfig.imageHeight,
      width: imageConfig.imageWidth,
      theme: theme,
      placeHolderBackground: "default"
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      bold: true,
      accessible: true,
      theme: theme,
      marginBottom: hasImage ? _constant2.SIZES.TINY : _constant2.SIZES.SMALL
    }, headingText), mainParaText ? /*#__PURE__*/_react.default.createElement(ParaContainer, null, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
      data: mainParaText,
      theme: theme,
      fontSize: _constant2.SIZES.XSMALL,
      customProperties: {
        id: 'generic-popup-para'
      }
    })) : /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      color: _constant2.COLORS.GREY_DARK,
      theme: theme,
      type: _constant2.SIZES.SMALL
    }, mainText), bulletParaText ? /*#__PURE__*/_react.default.createElement(BulletParaContainer, null, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
      data: mainParaText,
      theme: theme,
      fontSize: _constant2.SIZES.XSMALL,
      type: _constant2.PARA_TYPE.BULLET,
      bulletColor: _constant2.COLORS.GREY_DARK,
      customProperties: {
        id: 'generic-popup-para'
      }
    })) : /*#__PURE__*/_react.default.createElement(UlContainer, null, getBulletList()), (airAsiaPlusProps === null || airAsiaPlusProps === void 0 ? void 0 : airAsiaPlusProps.content) && airAsiaPlusProps.content.length > 0 && /*#__PURE__*/_react.default.createElement(ParaContainer, null, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
      type: _constants.PARAGRAPH_TYPES.ICON,
      data: renderContent(),
      theme: theme,
      fontSize: _constant2.SIZES.XSMALL,
      customProperties: {
        id: 'generic-popup-para'
      }
    })), paraAfterBulletPoints ? /*#__PURE__*/_react.default.createElement(ParaContainer, null, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
      data: paraAfterBulletPoints,
      theme: theme,
      fontSize: _constant2.SIZES.XSMALL,
      customProperties: {
        id: 'generic-popup-para'
      }
    })) : textAfterBulletPoints && /*#__PURE__*/_react.default.createElement(TextAfterBulletWrapper, null, getTextAfterBulletPoints()), (buttonTextLearnMore || buttonTextOk) && /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
      isMobile: isMobile(viewPort),
      hasImage: hasImage,
      isStickyBtn: isStickyBtn
    }, buttonTextLearnMore &&
    /*#__PURE__*/
    /* eslint-disable react/prop-types */
    _react.default.createElement(_Button.default, (0, _extends2.default)({
      accessible: true,
      backgroundColor: _constant2.COLORS.DEFAULT,
      boxShadow: true,
      width: buttonTextOk ? buttonWidth : _constant2.BUTTON_TYPE.BUTTON_FULL_WIDTH,
      buttonType: handleLearnMore ? _constant2.BUTTON_TYPE.BUTTON : _constant2.BUTTON_TYPE.LINK,
      color: _constant3.moveSecondaryButton[isMoveTheme].color,
      hoverBackgroundColor: _constant2.COLORS.GREY_LIGHTER,
      hoverColor: _constant3.moveSecondaryButton[isMoveTheme].hoverColor,
      border: _constant3.moveSecondaryButton[isMoveTheme].border,
      href: handleLearnMore ? '' : redirectionURL,
      size: _constant2.SIZES.NORMAL,
      target: target,
      theme: theme,
      margin: getMarginForButton(isMobile(viewPort)),
      handleClick: handleLearnMore
    }, secondaryButtonProps), buttonTextLearnMore), buttonTextOk &&
    /*#__PURE__*/
    /* eslint-disable react/prop-types */
    _react.default.createElement(_Button.default, (0, _extends2.default)({
      accessible: true,
      backgroundColor: _constant2.COLORS.PRIMARY,
      boxShadow: true,
      width: buttonTextLearnMore ? buttonWidth : _constant2.BUTTON_TYPE.BUTTON_FULL_WIDTH,
      buttonType: _constant2.BUTTON_TYPE.BUTTON,
      handleClick: handleClick,
      color: _constant3.movePrimaryButton[isMoveTheme].color,
      hoverBackgroundColor: _constant2.COLORS.PRIMARY_DARK,
      hoverColor: _constant3.movePrimaryButton[isMoveTheme].hoverColor,
      border: _constant3.movePrimaryButton[isMoveTheme].border,
      size: _constant2.SIZES.NORMAL,
      target: target,
      theme: theme
    }, primaryButtonProps), buttonTextOk))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
GenericPopUp.propTypes = _GenericPopUp.default.PropTypes;
GenericPopUp.defaultProps = _GenericPopUp.default.DefaultProps;
var _default = GenericPopUp;
exports.default = _default;